import { IBaseAction } from "../Actions/BaseAction";
import { App } from "../Enums/App";
import { MobilyticsQueryParam } from "../Models/MobilyticsQueryParam";

export interface IPlaceSearchRequest {
    app: App;
    placeId: string;
    sessionToken: google.maps.places.AutocompleteSessionToken;
};

export interface ILatLngSearchRequest {
    lat: number;
    lng: number;
};

export interface ILoadLocationsRequest {
    locations: MobilyticsQueryParam[];
}

export type DoPlaceSearchAction = IBaseAction<IPlaceSearchRequest>;
export type DoLatLngSearchAction = IBaseAction<ILatLngSearchRequest>;

export type PlaceSearchAction = DoPlaceSearchAction | DoLatLngSearchAction;

export type DoLoadLocationsAction = IBaseAction<ILoadLocationsRequest>;

export const DO_PLACE_SEARCH = "DO_PLACE_SEARCH";
export const DO_LATLNG_SEARCH = "DO_LATLNG_SEARCH";

export const DO_LOAD_LOCATIONS = "DO_LOAD_LOCATIONS";